<template>
  <div
    class="
      tw-border
      tw-border-dashed
      tw-bg-sf-snow-light
      tw-border-sf-snow-darker
      tw-rounded-lg
      tw-px-6
      tw-py-4
      tw-flex
      tw-items-center
      tw-justify-between
      tw-gap-4
      sf-pointer
    "
  >
    <div class="tw-flex tw-items-center tw-gap-3 tw-text-sf-gray tw-text-md">
      <i class="fas fa-file-upload tw-text-[18px] tw-text-sf-neutral"></i>
      <span>
        {{ copy.uploadTitle }}
        <span class="tw-text-sf-primary">{{ copy.browse }}</span>
      </span>
    </div>
    <div class="tw-text-sf-neutral-light tw-text-sm">.txt, .pdf, .jpg</div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
const copy = {
  uploadTitle: I18n.t(
    'client_meetings.prepare.external_note_modal.upload.title'
  ),
  browse: I18n.t('client_meetings.prepare.external_note_modal.upload.browse'),
}
</script>
